export interface User {
  id: string
  email: string
  displayName: string
  gender: 'male' | 'female' | 'other'
  birthDate: Date
  education: 'bachelor' | 'master' | 'phd'
  grade: number
  courses: string[]
  registeredAt: Date
  registeredBy: string
  loginCount: number
  lastLoginAt?: Date
  lastSeen?: Date
  fcmToken?: string
  totalScreenTime: number
}

export type AdminRole = 'super_admin' | 'admin' | 'senior_assistant' | 'assistant'

export interface Admin {
  id: string
  email: string
  displayName: string
  role: AdminRole
  createdAt: Date
  isActive: boolean
  lastSeen?: Date
}

// 角色顯示名稱
export const AdminRoleLabels: Record<AdminRole, string> = {
  super_admin: '超級管理員',
  admin: '老師',
  senior_assistant: '高級助理',
  assistant: '助理',
}

// 權限檢查 helper
// 注意：後端 Firestore Security Rules 也有對應的權限驗證
export const canManageAdmins = (role: AdminRole): boolean =>
  role === 'super_admin' || role === 'admin' || role === 'senior_assistant'
